const STEPS = [
  {
    title: 'Você diz quando.',
    desc:  'Data, hora e cidade de nascimento. Trinta segundos, uma vez só.',
  },
  {
    title: 'Analisamos seu mapa astral e previsões.',
    desc:  'Posições reais de todos os planetas no momento do seu nascimento: Sol, Lua, Ascendente, casas e aspectos.',
  },
  {
    title: 'Os astros falam com você.',
    desc:  'O seu mapa natal é lido e interpretado especificamente para você. Não o do seu signo. O seu.',
  },
];

export function HowItWorks() {
  return (
    <section
      id="ritual"
      style={{
        padding: 'clamp(4rem, 8vw, 7rem) 2rem',
        background: '#0A0416',
        borderTop: '1px solid rgba(212,175,55,0.1)',
      }}
    >
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase' as const,
          color: '#D4AF37',
          textAlign: 'center',
          marginBottom: '1.5rem',
        }}>
          Como funciona
        </p>
        <h2 style={{
          textAlign: 'center',
          margin: '0 0 4rem',
          color: 'rgba(240,246,252,0.95)',
          fontFamily: 'var(--font-display)',
        }}>
          Três momentos. Uma leitura.
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          {STEPS.map((step, i) => (
            <div
              key={i}
              style={{
                display: 'grid',
                gridTemplateColumns: '48px 1fr',
                gap: '2rem',
                padding: '2.5rem 0',
                borderTop: '1px solid rgba(212,175,55,0.12)',
                alignItems: 'start',
              }}
            >
              <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                border: '1px solid rgba(212,175,55,0.4)',
                background: 'rgba(212,175,55,0.06)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}>
                <span style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'var(--text-22)',
                  fontWeight: 300,
                  fontStyle: 'italic',
                  color: '#D4AF37',
                  lineHeight: 1,
                }}>
                  {i + 1}
                </span>
              </div>

              <div>
                <h3 style={{
                  fontSize: 'var(--text-22)',
                  fontStyle: 'italic',
                  margin: '0.2rem 0 0.75rem',
                  color: 'rgba(240,246,252,0.95)',
                }}>
                  {step.title}
                </h3>
                <p style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'var(--text-18)',
                  fontWeight: 300,
                  color: 'rgba(200,220,235,0.7)',
                  lineHeight: 1.7,
                  margin: 0,
                }}>
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
